import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { MetricsPage } from "@/components/metrics/metrics-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/metrics",
  component: MetricsGuard,
});

function MetricsGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <MetricsPage />;
}
